export default __webpack_public_path__ + "static/media/Adjuntar.b8e30bd7.svg";